<template>

  <div>

    <a-card :bordered="false" :title="this.title">
      <div>
        <a-menu v-model="current" mode="horizontal">
          <a-menu-item @click="handleClick" key="OrderFlag">{{$t('message.aegInboundDetail.title.orderStatus')}}</a-menu-item>
          <a-menu-item @click="handleClick" key="BasicFlag" > {{$t('message.aegInboundDetail.title.basicInformation')}}  </a-menu-item>
          <a-menu-item @click="handleClick" key="SkuFlag" > {{$t('message.aegInboundDetail.title.skus')}} </a-menu-item>
          <a-menu-item @click="handleClick" key="BatchFlag" >{{$t('message.aegInboundDetail.title.batchInformation')}} </a-menu-item>
          <a-menu-item @click="handleClick" key="Guidelines" >{{$t('message.aegInboundDetail.title.logisticLogs')}} </a-menu-item>
        </a-menu>
      </div>
    </a-card>
    <br>
    <a-card :bordered="false" id="OrderFlag" :title="$t('message.aegInboundDetail.title.orderStatus')" >
      <a-steps progress-dot :current="this.currentNode" class="a-step-container">
        <template v-for="node in processNodes">
          <a-step :title="node.bizStatusDesc" :description="node.finishTime"/>
        </template>
      </a-steps>
    </a-card>

    <br>
    <a-card :bordered="false" id="BasicFlag" :title="$t('message.aegInboundDetail.title.basicInformation')" >
      <a-descriptions>
        <a-descriptions-item :label="$t('message.aegInboundDetail.title.channel')">
          {{this.purchaseOrderDetail.modeDesc}}
        </a-descriptions-item>

        <a-descriptions-item :label="$t('message.aegInboundDetail.title.cancelPerson')">
          {{this.purchaseOrderDetail.extFields.cancelOperator}}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('message.aegInboundDetail.title.cancelTime')">
          {{this.purchaseOrderDetail.extFields.cancelTime}}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('message.aegInboundDetail.title.cancelReason')">
          {{this.purchaseOrderDetail.extFields.cancelRemark}}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('message.aegInboundDetail.title.creator')">
          {{this.purchaseOrderDetail.creator}}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('message.aegInboundDetail.title.createTime')">
          {{this.purchaseOrderDetail.formatGmtCreate}}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('message.aegInboundDetail.title.expectedTime')">
          {{this.purchaseOrderDetail.extFields.preArrivalTimeFormat}}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('message.aegInboundDetail.title.expiredTime')">
          {{this.purchaseOrderDetail.extFields.gmtExpiredTimeFormat}}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('message.aegInboundDetail.title.actualArrivalTime')">
          {{this.purchaseOrderDetail.extFields.actualArrivalTimeFormat}}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('message.aegInboundDetail.title.storeCode')">
          {{this.purchaseOrderDetail.storeCode}}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('message.aegInboundDetail.title.warehouseAddress')">
          {{this.purchaseOrderDetail.attributeHolder.warehouseAddress}}
        </a-descriptions-item>
        <a-descriptions-item :label="$t('message.aegInboundDetail.title.remart')">
          {{this.purchaseOrderDetail.extFields.remark}}
        </a-descriptions-item>
      </a-descriptions>
    </a-card>

    <a-card :bordered="false" id="SkuFlag" :title="$t('message.aegInboundDetail.title.skus')">
      <a-table :columns="columns" :rowKey="rowKey" :dataSource="dataSource" :pagination="pagination" :loading="loading"
               @change="getPurchaseItemsData"
               :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      >
      </a-table>
    </a-card>

    <a-card :bordered="false" id="BatchFlag" :title="$t('message.aegInboundDetail.title.batchInformation')">
      <a-table :columns="consignColumns" :rowKey="rowKey" :dataSource="consignDataSource"
               :pagination="consignPagination" :loading="consignLoading" @change="queryConsignOrder"
               :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onConsignSelectChange }"
      >
        <template slot="action" slot-scope="text,record">
          <a slot="action" href="javascript:;" @click="showOrderDetail(record)">{{$t('message.aegInboundDetail.btn.detail')}}</a>
        </template>
      </a-table>
    </a-card>

    <a-card :bordered="false" id="Guidelines" :title="$t('message.aegInboundDetail.title.logisticLogs')">
      <a-table :columns="logisticColumns" :rowKey="rowKey" :dataSource="logisticDataSource">
      </a-table>
    </a-card>

    <!--批次货品详情对话框信息-->
    <div>
      <a-modal
        :title="$t('message.aegInboundDetail.title.skus')"
        :visible="newOrderDialog.visible"
        :confirm-loading="newOrderDialog.confirmLoading"
        @ok="addNewOrderHandleCancel"
        @cancel="addNewOrderHandleCancel"
        :width="800"
      >
        <a-table :columns="goodColumns"  :rowKey="rowKey" :dataSource="goodDataSource">
        </a-table>
      </a-modal>
    </div>

  </div>

</template>

<script>

  import {InboundApi} from '../../js/InboundApi'
  import request from '../../utils/request'

  export default {
  computed: {
    columns () {
      return [
        {
          title: this.$t('message.aegOutboundOrderDetail.purchaseItemColumn.scItemId'),
          dataIndex: 'scItemId'
        },
        {
          title: this.$t('message.aegOutboundOrderDetail.purchaseItemColumn.title'),
          dataIndex: 'title'

        },
        {
          title: this.$t('message.aegOutboundOrderDetail.purchaseItemColumn.measureUnit'),
          dataIndex: 'measureUnit'
        },
        {
          title: this.$t('message.aegOutboundOrderDetail.purchaseItemColumn.quantityDec'),
          dataIndex: 'quantityDec'
        },
        {
          title: this.$t('message.aegOutboundOrderDetail.purchaseItemColumn.sentQty'),
          dataIndex: 'sentQty'
        },
        {
          title: this.$t('message.aegOutboundOrderDetail.purchaseItemColumn.receivedNormalQty'),
          dataIndex: 'receivedNormalQty'
        },
        {
          title: this.$t('message.aegOutboundOrderDetail.purchaseItemColumn.receivedDefectiveQtyDec'),
          dataIndex: 'receivedDefectiveQtyDec'
        }
      ]
    },
    consignColumns () {
      return [
        {
          title: this.$t('message.aegOutboundOrderDetail.consignColumn.purchaseOrderNo'),
          dataIndex: 'purchaseOrderNo'
        },
        {
          title: this.$t('message.aegOutboundOrderDetail.consignColumn.supplierName'),
          dataIndex: 'supplierName'

        },
        {
          title: this.$t('message.aegOutboundOrderDetail.consignColumn.inboundNo'),
          dataIndex: 'inboundNo'
        },
        {
          title: this.$t('message.aegOutboundOrderDetail.consignColumn.reserveOrderNo'),
          dataIndex: 'reserveOrderNo'
        },
        {
          title: this.$t('message.aegOutboundOrderDetail.consignColumn.formatPreArriveTime'),
          dataIndex: 'formatPreArriveTime'
        },
        {
          title: this.$t('message.aegOutboundOrderDetail.consignColumn.creator'),
          dataIndex: 'creator'
        },
        {
          title: this.$t('message.aegOutboundOrderDetail.consignColumn.gmtCreateStr'),
          dataIndex: 'gmtCreateStr'
        },
        {
          title: this.$t('message.aegOutboundOrderDetail.consignColumn.gmtConfirmReceiveStr'),
          dataIndex: 'gmtConfirmReceiveStr'
        }, {
          title: this.$t('message.aegOutboundOrderDetail.consignColumn.operate'),
          scopedSlots: {customRender: 'action'}
        }
      ]
    },
    goodColumns () {
      return [
        {
          title:  this.$t('message.aegInboundDetail.goodsTable.scItemId'),
          dataIndex: 'scItemId'
        },
        {
          title:  this.$t('message.aegInboundDetail.goodsTable.title'),
          dataIndex: 'title'

        },
        {
          title:  this.$t('message.aegInboundDetail.goodsTable.barcode'),
          dataIndex: 'barcode'
        },
        {
          title:  this.$t('message.aegInboundDetail.goodsTable.quantityDec'),
          dataIndex: 'quantityDec'
        },
        {
          title:  this.$t('message.aegInboundDetail.goodsTable.normalQtyDec'),
          dataIndex: 'quantityDec'
        },
        {
          title:  this.$t('message.aegInboundDetail.goodsTable.normalQtyDec'),
          dataIndex: 'normalQtyDec'
        },
        {
          title: this.$t('message.aegInboundDetail.goodsTable.defectiveQtyDec'),
          dataIndex: 'defectiveQtyDec'
        }
      ]
    },
    logisticColumns () {
      return [
        {
          title: this.$t('message.aegInboundDetail.logisticColumn.operateTime'),
          dataIndex: 'operateTime'
        },
        {
          title: this.$t('message.aegInboundDetail.logisticColumn.operator'),
          dataIndex: 'operator'

        },
        {
          title: this.$t('message.aegInboundDetail.logisticColumn.bizOrderNo'),
          dataIndex: 'bizOrderNo'
        },
        {
          title: this.$t('message.aegInboundDetail.logisticColumn.fulfillStatus'),
          dataIndex: 'fulfillStatus'
        },
        {
          title: this.$t('message.aegInboundDetail.logisticColumn.fulfillStatusDesc'),
          dataIndex: 'fulfillStatusDesc'
        }
      ]
    }
  },
  data () {
    return {
      processNodes: [],
      purchaseOrderNo: '',
      title: '',
      currentNode: 0,
      purchaseOrderDetail: null,
      purchaseOrderItems: null,
      pagination: {
        defaultPageSize: 10,
        current: 1,
        pageSize: 10,
        total: 0,
        onChange: current => {
          // 切换分页时的回调，
          this.pagination.current = current
          console.log('change current=', this.pagination.current)
          this.getPurchaseItemsData(this.purchaseOrderNo)
        }
      },
      rowKey: 'id',
      loading: true,
      dataSource: this.dataSource,
      selectedRowKeys: [], // Check here to configure the default column,

      consignPagination: {
        defaultPageSize: 10,
        current: 1,
        pageSize: 10,
        total: 0,
        onChange: current => {
          // 切换分页时的回调，
          this.pagination.current = current
          this.queryConsignOrder(this.purchaseOrderNo)
        }
      },
      consignDataSource: this.consignDataSource,
      consignLoading: true,
      newOrderDialog: {
        visible: false,
        confirmLoading: false
      },
      goodDataSource: this.goodDataSource,
      logisticDataSource: this.logisticDataSource
    }
  },
  created () {
    const purchaseLineData = this.$route.query.purchaseLineData
    this.purchaseOrderNo = purchaseLineData.purchaseOrderNo
    this.title = this.purchaseOrderNo
    this.queryProcessNode(this.purchaseOrderNo)
    this.queryAegPurchaseDetail(this.purchaseOrderNo)
    this.getPurchaseItemsData(this.purchaseOrderNo)
    this.queryConsignOrder(this.purchaseOrderNo)
  },
  mounted () {
  },
  methods: {
    onChange (date, dateString) {
    },
    queryProcessNode (purchaseOrderNo) {
      request({
        url: InboundApi.InboundFromUrl.queryProcessNodes,
        method: 'get',
        headers: {
          requestUserId: InboundApi.requestUserId
        },
        params: {
          purchaseOrderNo: purchaseOrderNo
        }
      }).then(response => {
        console.log(response.data.model)
        this.processNodes = response.data.model
        var nodeNum = 0
        this.processNodes.some(function (node) {
          if (node.currentStatus == false) {
            nodeNum = nodeNum + 1
          } else {
            return true
          }
        })
        this.currentNode = nodeNum
        console.log(this.currentNode)
      })
    },
    queryAegPurchaseDetail (purchaseOrderNo) {
      request({
        url: InboundApi.InboundFromUrl.queryAegPurchaseOrderDetail,
        method: 'get',
        headers: {
          requestUserId: InboundApi.requestUserId
        },
        params: {
          purchaseOrderNo: purchaseOrderNo
        }
      }).then(response => {
        this.purchaseOrderDetail = JSON.parse(response.data.model)
      })
    },
    getPurchaseItemsData (purchaseOrderNo) {
      this.loading = true
      request({
        url: InboundApi.InboundFromUrl.queryPurchaseOrderItemsUrl,
        method: 'get',
        headers: {
          requestUserId: InboundApi.requestUserId
        },
        params: {
          purchaseOrderNo: purchaseOrderNo,
          pageIndex: 1,
          pageSize: 50
        }

      }).then(response => {
        this.purchaseOrderItems = response.data.model
        this.dataSource = this.purchaseOrderItems
        const pagination = {...this.pagination}
        // 获取数组大小
        pagination.total = response.data.totalCount
        this.pagination = pagination
        this.loading = false
      })
    },
    queryConsignOrder (purchaseOrderNo) {
      this.consignLoading = true
      request({
        url: InboundApi.InboundFromUrl.queryConsignOrderUrl,
        method: 'get',
        headers: {
          requestUserId: InboundApi.requestUserId
        },
        params: {
          purchaseOrderNo: purchaseOrderNo
        }

      }).then(response => {
        console.log(response.data.model)
        this.consignDataSource = response.data.model
        const pagination = {...this.pagination}
        // 获取数组大小
        pagination.total = response.data.totalCount
        this.consignPagination = pagination
        this.consignLoading = false

        // if (this.consignDataSource != null) {
        //   this.queryLogisticOrder(this.consignDataSource[0].reserveOrderNo, this.consignDataSource[0].consignOrderNo)
        // }
      })
    },

    queryLogisticOrder (appointOrderCode, bizOrderNo) {
      request({
        url: InboundApi.InboundFromUrl.queryLogisticOrderUrl,
        method: 'get',
        headers: {
          requestUserId: InboundApi.requestUserId
        },
        params: {
          appointOrderCode: appointOrderCode,
          orderCode: bizOrderNo
        }

      }).then(response => {
        this.logisticDataSource = response.data.model
      })
    },
    // 表格选择事件
    onSelectChange (selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys)
      this.selectedRowKeys = selectedRowKeys
    },
    onConsignSelectChange (selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys)
      this.selectedRowKeys = selectedRowKeys
    },
    addNewOrderHandleCancel () {
      this.newOrderDialog.visible = false
    },
    showOrderDetail (record) {
      this.newOrderDialog.visible = true
      this.goodDataSource = record.items
    },
    handleClick (e) {
      console.log(e.key)
      var selector = '#' + e.key
      document.querySelector(selector).scrollIntoView(true, {behavior: 'instant', block: 'start'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/icp/InboundDetail.vue